export abstract class AmplifyApiEnvironment {
  abstract readonly amplify: {
    readonly Auth:any;
    readonly API:any;
  };
}